import { Sparkles } from 'lucide-react';
import { useReducedMotion } from 'framer-motion';
import { landing } from 'constants/copy';
import { cn } from 'utils/cn';

export function AskGuruNavLabel({
  className,
  active = false,
  iconOnly = false,
}: {
  className?: string;
  active?: boolean;
  iconOnly?: boolean | 'responsive';
}) {
  const reduceMotion = useReducedMotion();
  const responsive = iconOnly === 'responsive';
  const hideLabel = iconOnly === true || responsive;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border font-semibold tracking-tight transition-colors',
        hideLabel ? 'justify-center px-2 py-2 md:gap-1.5 md:px-2.5 md:py-0.5' : 'px-2.5 py-0.5 text-[13px]',
        active
          ? 'border-accent/50 bg-accent/12 text-accent-strong shadow-sm dark:border-gold/45 dark:bg-gold/15 dark:text-gold-light'
          : 'border-brand-purple/25 bg-brand-purple/[0.06] text-brand-purple dark:border-gold/30 dark:bg-gold/[0.08] dark:text-gold-light',
        className,
      )}
    >
      <Sparkles
        className={cn(
          'shrink-0',
          hideLabel ? 'h-4 w-4' : 'h-3 w-3',
          active ? 'text-accent-strong dark:text-gold' : 'text-gold dark:text-gold-light',
          !reduceMotion && !active && 'animate-pulse',
        )}
        aria-hidden
      />
      <span
        className={cn(
          iconOnly === true && 'sr-only',
          responsive && 'hidden md:inline md:text-[13px]',
        )}
      >
        {landing.nav.aiGuru}
      </span>
    </span>
  );
}
